import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";
import Header from "../Component/Header";
import Footer from "../Component/Footer";

const yearWiseData = {
  2026: {
    summer: {
      academics: [
      { title: "Nursery", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/HHW-NUR_2026_summer_academics.pdf" },
      { title: "LKG", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/HHW-LKG_2026_summer_academics.pdf" },
      { title: "UKG", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/HHW-UKG_2026_summer_academics.pdf" },
      { title: "Class 1", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/HHW-class1_2026_summer_academics.pdf" },
      { title: "Class 2", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/HHW-class2_2026_summer_academics.pdf" },
      { title: "Class 3", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/HHW-class3_2026_summer_academics.pdf" },
      { title: "Class 4", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/HHW-class4_2026_summer_academics.pdf" },
      { title: "Class 5", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/HHW-class5_2026_summer_academics.pdf" },
      { title: "Class 6", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/HHW-class6_2026_summer_academics.pdf" },
      { title: "Class 8", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/HHW-class8_2026_summer_academics.pdf" },
      { title: "Class 9", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/HHW-class9_2026_summer_academics.pdf" },
      { title: "Class 10", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/HHW-class10_2026_summer_academics.pdf" },
      { title: "Class 11 - A Commerce", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/HHW-class11A_2026_summer_academics.pdf" },
      { title: "Class 11 - B Medical", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/HHW-class11B_2026_summer_academics.pdf" },
      { title: "Class 11 - C Non Medical", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/HHW-class11C_2026_summer_academics.pdf" },
      // { title: "Class 9", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/HHW-class9_2026_summer_academics.pdf" },
      ],
      robotics: [],
    },
    winter: {
      academics: [],
      robotics: [],
    },
  },
  2025: {
    summer: {
      academics: [
      { title: "Nursery", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/Nurseryhomework.pdf" },
      { title: "LKG", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/LKGhomework.pdf" },
      { title: "UKG", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/UKGhomework.pdf" },
      { title: "Class I", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/classIhomework.pdf" },
      { title: "Class II", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/classIIhomework.pdf" },
      { title: "Class III", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/classIIIhomework.pdf" },
      { title: "Class IV", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/classIVhomework.pdf" },
      { title: "Class V", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/classVhomework.pdf" },
      { title: "Class VI", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/classVIhomework.pdf" },
      { title: "Class VII", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/classVIIhomework.pdf" },
      { title: "Class VIII", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/classVIIIhomework.pdf" },
      { title: "Class IX", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/classIXhomework.pdf" },
      { title: "Class X", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/classXhomework.pdf" },
      ],
      robotics: [{ title: "Robotics", href: "https://webapi.entab.info/api/image/STPSFH/public/pdf/RoboticsHolidayHomework.pdf" }],
    },
    winter: {
      academics: [],
      robotics: [],
    },
  },
};

const HolidaysHomework = () => {
  const [selectedYear, setSelectedYear] = useState("2026");
  useEffect(() => {
    document.title =
      "Curriculum Extension Activities -  St Peters convent School Faridabad Haryana";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>
          </li>
          <li> Academics </li>
          <li>Curriculum Extension Activities </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Curriculum Extension Activities </h1>
            </div>
          </div>
          <div className="row" id="homeworktabsec">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-4">
                  <select
                    className="form-control"
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                  >
                    <option value="2026">2026</option>
                    <option value="2025">2025</option>
                  </select>
                </div>
              </div>
              <nav>
                <div
                  class="nav nav-tabs homeworktab"
                  id="nav-season-tab"
                  role="tablist"
                >
                  <button
                    class="nav-link active"
                    id="summer-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#summer"
                    type="button"
                    role="tab"
                    aria-controls="summer"
                    aria-selected="true"
                  >
                    Summer Break Activities
                  </button>
                  <button
                    class="nav-link"
                    id="winter-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#winter"
                    type="button"
                    role="tab"
                    aria-controls="winter"
                    aria-selected="false"
                  >
                    Winter Break Activities
                  </button>
                </div>
              </nav>
              <div class="tab-content" id="nav-season-tabContent">
                <div
                  class="tab-pane fade show active"
                  id="summer"
                  role="tabpanel"
                  aria-labelledby="summer-tab"
                >
                  {/* <div className="row">
                    <div className="col-lg-4">
                      <select className="form-control">
                        <option>2025</option>
                      </select>
                    </div>
                  </div> */}
                  <nav>
                    <div
                      class="nav nav-tabs homeworktab"
                      id="nav-summer-tab"
                      role="tablist"
                    >
                      <button
                        class="nav-link active"
                        id="summer-academics-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#summer-academics"
                        type="button"
                        role="tab"
                        aria-controls="summer-academics"
                        aria-selected="true"
                      >
                        Academics
                      </button>
                      <button
                        class="nav-link"
                        id="summer-robotics-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#summer-robotics"
                        type="button"
                        role="tab"
                        aria-controls="summer-robotics"
                        aria-selected="false"
                      >
                        Robotics
                      </button>
                    </div>
                  </nav>
                  <div class="tab-content" id="nav-summer-tabContent">
                    <div
                      class="tab-pane fade show active"
                      id="summer-academics"
                      role="tabpanel"
                      aria-labelledby="summer-academics-tab"
                    >
                      <div className="row">
                        {yearWiseData[selectedYear].summer.academics.map((item) => (
                          <div className="col-lg-4" key={`${selectedYear}-academics-${item.title}`}>
                            <a href={item.href} target="_blank" rel="noreferrer">
                              <div class="sample-blk">
                                <div>
                                  <p> {item.title}</p>
                                </div>
                                <LazyLoad>
                                  <img
                                    alt="STPCH"
                                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                    class="img-fluid"
                                  />
                                </LazyLoad>
                              </div>
                            </a>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="summer-robotics"
                      role="tabpanel"
                      aria-labelledby="summer-robotics-tab"
                    >
                      <div className="row">
                        {yearWiseData[selectedYear].summer.robotics.length > 0 ? (
                          yearWiseData[selectedYear].summer.robotics.map((item) => (
                            <div className="col-lg-4" key={`${selectedYear}-robotics-${item.title}`}>
                              <a href={item.href} target="_blank" rel="noreferrer">
                                <div class="sample-blk">
                                  <div>
                                    <p> {item.title}</p>
                                  </div>
                                  <LazyLoad>
                                    <img
                                      alt="STPCH"
                                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                      class="img-fluid"
                                    />
                                  </LazyLoad>
                                </div>
                              </a>
                            </div>
                          ))
                        ) : (
                          <div className="col-lg-12">
                            <p>No content available.</p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="winter"
                  role="tabpanel"
                  aria-labelledby="winter-tab"
                >
                  <nav>
                    <div
                      class="nav nav-tabs homeworktab"
                      id="nav-winter-tab"
                      role="tablist"
                    >
                      <button
                        class="nav-link active"
                        id="winter-academics-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#winter-academics"
                        type="button"
                        role="tab"
                        aria-controls="winter-academics"
                        aria-selected="true"
                      >
                        Academics
                      </button>
                      <button
                        class="nav-link"
                        id="winter-robotics-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#winter-robotics"
                        type="button"
                        role="tab"
                        aria-controls="winter-robotics"
                        aria-selected="false"
                      >
                        Robotics
                      </button>
                    </div>
                  </nav>
                  <div class="tab-content" id="nav-winter-tabContent">
                    <div
                      class="tab-pane fade show active"
                      id="winter-academics"
                      role="tabpanel"
                      aria-labelledby="winter-academics-tab"
                    >
                      <div className="row">
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/Activities_winter_break_NURSERY.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Nursery</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/Activities_Winter_Break_LKG.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> LKG</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/Winter_Break_Class_1.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Class I</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/WINTER_BREAK_class_2.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Class II</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/Activities_Winter_Break_class_4.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Class IV</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/Activities_Winter_break _class_5.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Class V</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/ACTIVITIES_WINTER_BREAK_class_6.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Class VI</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/Activities_wnter_break_class_7.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Class VII</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/Activities_winter_break_class_8.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Class VIII</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="winter-robotics"
                      role="tabpanel"
                      aria-labelledby="winter-robotics-tab"
                    >
                      <div className="row">
                        <div className="col-lg-12">
                          <p>No content available.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default HolidaysHomework;
